import React, {
  ComponentPropsWithoutRef,
  FC,
  MutableRefObject,
  ReactNode,
  useRef,
  useState,
  useEffect,
} from 'react';
import { StyledComponent } from 'styled-components';
import BackToTopButton from './BackToTopButton';

type StyledDiv = StyledComponent<'div', any, Record<string, unknown>, never>;
interface ComponentProps {
  WrapperContainer: StyledDiv;
  children: ReactNode;
  refOverride?: MutableRefObject<HTMLDivElement>;
  className?: string;
}

export type ScrollableContainerWrapperProps = ComponentProps & ComponentPropsWithoutRef<StyledDiv>;

const ScrollableContainerWrapper: FC<ScrollableContainerWrapperProps> = ({
  WrapperContainer,
  children,
  refOverride,
  ...wrapperProps
}: ScrollableContainerWrapperProps) => {
  const wrapperRef = useRef<HTMLDivElement>();
  const scrollableTargetRef = refOverride || wrapperRef;
  const [scrollableTarget, setScrollableTarget] = useState<HTMLElement>();

  useEffect(() => {
    setScrollableTarget(scrollableTargetRef.current);
  }, []);

  return (
    <WrapperContainer ref={scrollableTargetRef} {...wrapperProps}>
      {children}
      <BackToTopButton scrollableTarget={scrollableTarget} />
    </WrapperContainer>
  );
};

export default ScrollableContainerWrapper;
